module.exports = __webpack_public_path__ + "img/card_status_120_dias.22d94a09.svg";